<template>
<div class="page page_hezuo">
    <!-- 直播 -->
    <div class="bg tradesman">直播申请</div>
    <div class="step">
        <!-- 进行状态 加active类 ; 非进行状态 不加-->
        <div class="step_item active">
            <div class="step_name">填写信息</div>
            <div class="step_icon active">
                <div class="icon"></div>
            </div>
        </div>
        <div class="step_item active">
            <div class="step_name">审核</div>
            <div :class="status!=0 ? 'step_icon active':'step_icon'">
                <div class="icon"></div>
            </div>
        </div>
        <div :class="status!=0 ? 'step_item active': 'step_item'">
            <div class="step_name">{{status==2?'审核失败' :'申请成功'}}</div>
            <div class="step_icon">
                <div class="icon"></div>
            </div>
        </div>
    </div>
    <!-- 审核中 -->
    <div class="status" v-if="status == 0">
        <div class="tu">
            <img :src="publicPath+'statics/images/jiangren/applying.png'" alt="" class="">
        </div>
        <div class="status_tip">已提交，系统审核中<br />请您耐心等待</div>
    </div>
    <!-- 审核失败 -->
    <div class="status" v-if="status == 2">
        <div class="tu">
            <img :src="publicPath+'statics/images/jiangren/applyfailed.png'" alt="" class="">
        </div>
        <div class="status_tip">审核失败<br />请联系客服，客服电话16601367749</div>
        <div class="big_btn bottom" @click="reSubmit">重新提交</div>
    </div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
            status: 0 // 审核状态 0审核中 1审核成功 2审核失败
        };
    },
    created: function () {
        if (this.$route.query.status) {
            this.status = this.$route.query.status
        }
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //设置导航栏
            var params = {
                'data': {
                    'naviTitle': '审核状态'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
        }
    },
    methods: {
        reSubmit(){
            // 1匠人 2供应商 3代理商 4城市合伙人
            this.$router.push({
                name: 'zhibo-apply'
            })
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.page .upload-images {
    margin-top: .4rem;
}
</style>
